import { PaymentTypeMessages } from "@/messages/platforms/talk2PayHome/payment-type.messages";

export const PAYMENT_TYPE_TABLE_COLUMNS = (messages: PaymentTypeMessages) => [
  messages.paymentTypeColumn,
  messages.discountAppliedColumn,
  messages.discountOverColumn,
  messages.activeColumn,
  messages.optionsColumn,
];
